import React from "react";

const statusConfig = {
  running:   { class: "dot-running", text: "Active" },
  pending:   { class: "dot-pending", text: "Pending" },
  processing:{ class: "dot-processing", text: "Active" },
  paused:    { class: "dot-paused", text: "Paused" },
  completed: { class: "dot-completed", text: "Completed" },
  failed:    { class: "dot-failed", text: "Failed" },
  stopped:   { class: "dot-stopped", text: "Stopped" },
  draft:     { class: "dot-draft", text: "Draft" },
};

const SmsCampaignStatusBadge = ({ status }) => {
    const config = statusConfig[status] || { class: "dot-default", text: status };

    return (
        <div className="custom-status-badge">
        <span className={`status-dot ${config.class}`}></span>
        <span className="status-text">{config.text}</span>
        </div>
    );
};

export default SmsCampaignStatusBadge;